"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSettings = MenuSettings;
const React = __importStar(require("react"));
const ui_1 = require("@creature-chess/ui");
const plugins_1 = require("~/plugins");
const settings_1 = require("~/settings");
const useStyles = (0, ui_1.createUseThemeStyles)((theme) => ({
    settings: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        color: theme.palette.light.neutral,
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    title: {
        fontSize: "1.5rem",
    },
    row: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        fontSize: "1.1rem",
    },
}));
function MenuSettings({ onBack }) {
    const classes = useStyles();
    const showPing = (0, settings_1.useSetting)("showPing");
    const setShowPing = (0, settings_1.useSetSetting)("showPing");
    return (React.createElement(ui_1.Panel, null,
        React.createElement("div", { className: classes.settings },
            React.createElement("div", { className: classes.header },
                React.createElement("span", { className: classes.title }, "Settings"),
                React.createElement(ui_1.Button, { color: "muted", size: "small", onClick: onBack }, "Back")),
            React.createElement("label", { className: classes.row },
                React.createElement("input", { type: "checkbox", checked: showPing, onChange: () => setShowPing(!showPing) }),
                "Show ping"),
            React.createElement(plugins_1.Region, { cls: "settings-section", id: "menu.settings", ctx: {} }))));
}
